<template>
  <section>
    <!--MULTISELECT WITH GROUP-->
    <multiselect
      v-if="group"
      :id="`multiselect__tags--${id}`"
      :value="includedTags"
      :options="options"
      :close-on-select="true"
      :preserve-search="true"
      :group-values="groupValues"
      group-label="name"
      :group-select="false"
      :label="optionLabel"
      :option-height="48"
      :options-limit="optionsLimit"
      :track-by="trackBy"
      :multiple="true"
      :show-labels="true"
      select-label=""
      selected-label=""
      deselect-label=""
      @open="handleOpen"
      @focus.stop=""
      @select="(selectedOption, id) => includeTag(selectedOption)"
      @remove="(selectedOption, id)=> removeTag(selectedOption)"
    >
      <template slot="placeholder">
        <span class="multiselect__placeholder mb-0">{{ placeholder }}</span>
      </template>
      <template
        slot="option"
        slot-scope="props"
      >
        <div class="option__desc">
          <span
            v-if="props.option.$groupLabel"
          >
            <GjIcon
              v-if="icon !== ''"
              class="mr-50"
              :name="icon"
            />
            {{ props.option.$groupLabel }}
          </span>
          <span
            v-else
            class="option__title ml-1 d-flex justify-content-between"
          >
            <span>
              <GjIcon
                v-if="icon !== ''"
                class="mr-50"
                :name="icon"
              />
              {{ props.option[optionLabel] }}
            </span>
            <GjIcon
              v-if="includedTags ? includedTags.some(tag => tag.id === props.option.id) : false"
              class="mr-50"
              name="Check"
            />
          </span>
        </div>
      </template>
      <template
        slot="selection"
        slot-scope="{values, remove}"
      >
        <template v-if="isOverflowing">
          <div class="multiselect__tags-wrap">
            <template v-for="(value, valueIndex) in values">
              <span
                v-if="valueIndex < index || index === -1"
                :key="value.id"
                class="multiselect__tag"
              >
                <span>{{ value[optionLabel] }}</span>
                <i
                  class="multiselect__tag-icon"
                  aria-hidden="true"
                  tabindex="1"
                  @click="remove(value)"
                />
              </span>
            </template>
            <b-dropdown
              v-if="index != -1 && index < values.length"
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              class="multiselect__tag--dropdown"
              no-caret
            >
              <template #button-content>
                <span
                  :id="`multiselect__tag__more-${id}`"
                  class="multiselect__tag py-0 px-50"
                >
                  <GjIcon
                    name="Moreoptions"
                    size="22"
                  />
                </span>
              </template>
              <b-dropdown-item
                v-for="(value, valueIndex) in values.slice(index)"
                :key="valueIndex"
              >
                <span
                  :key="value.id"
                  class="multiselect__tag"
                >
                  <span>{{ value[optionLabel] }}</span>
                  <i
                    class="multiselect__tag-icon"
                    aria-hidden="true"
                    tabindex="1"
                    @click="remove(value)"
                  />
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template v-else>
          <div class="multiselect__tags-wrap">
            <span
              v-for="value in values"
              :key="value.id"
              class="multiselect__tag"
            >
              <span>{{ value[optionLabel] }}</span>
              <i
                class="multiselect__tag-icon"
                aria-hidden="true"
                tabindex="1"
                @click="remove(value)"
              />
            </span>
          </div>
        </template>

      </template>
      <template
        slot="caret"
        slot-scope="{ toggle }"
      >
        <div
          class="multiselect__select"
          @mousedown.prevent.stop="toggle()"
        >
          <GjIcon
            class="icon-wrapper"
            name="ArrowDown_fill"
            size="21"
          />
        </div>
      </template>
    </multiselect>
    <!--MULTISELECT WITHOUT GROUP-->
    <multiselect
      v-else
      :id="`multiselect__tags--${id}`"
      :value="includedTags"
      :options="options"
      :close-on-select="true"
      :preserve-search="true"
      :label="optionLabel"
      :track-by="trackBy"
      :options-limit="optionsLimit"
      :multiple="true"
      :show-labels="true"
      select-label=""
      selected-label=""
      deselect-label=""
      @open="handleOpen"
      @focus.stop=""
      @select="(selectedOption, id) => addOption(selectedOption)"
      @remove="(selectedOption, id)=> removeOption(selectedOption)"
    >
      <template slot="placeholder">
        <span class="multiselect__placeholder mb-0">{{ placeholder }}</span>
      </template>
      <template
        slot="option"
        slot-scope="props"
      >
        <div class="option__title d-flex justify-content-between">
          {{ props.option[optionLabel] }}
          <GjIcon
            v-if="includedTags ? includedTags.some(tag => tag[keyBy] === props.option[keyBy]) : false"
            class="mr-50"
            name="Check"
          />
        </div>
      </template>
      <template
        slot="selection"
        slot-scope="{remove}"
      >
        <template v-if="isOverflowing">
          <div class="multiselect__tags-wrap">
            <template v-for="(value, valueIndex) in includedTags">
              <span
                v-if="valueIndex < index || index === -1"
                :key="value[keyBy]"
                class="multiselect__tag"
              >
                <span>{{ value[optionLabel] }}</span>
                <i
                  class="multiselect__tag-icon"
                  aria-hidden="true"
                  tabindex="1"
                  @click="remove(value)"
                />
              </span>
            </template>
            <b-dropdown
              v-if="index != -1 && index < includedTags.length"
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              class="multiselect__tag--dropdown"
              no-caret
            >
              <template #button-content>
                <span
                  :id="`multiselect__tag__more-${id}`"
                  class="multiselect__tag py-0 px-50"
                >
                  <GjIcon
                    name="Moreoptions"
                    size="22"
                  />
                </span>
              </template>
              <b-dropdown-item
                v-for="(value, valueIndex) in includedTags.slice(index)"
                :key="valueIndex"
              >
                <span
                  :key="value[keyBy]"
                  class="multiselect__tag"
                >
                  <span>{{ value[optionLabel] }}</span>
                  <i
                    class="multiselect__tag-icon"
                    aria-hidden="true"
                    tabindex="1"
                    @click="remove(value)"
                  />
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template v-else>
          <div class="multiselect__tags-wrap">
            <span
              v-for="value in includedTags"
              :key="value[keyBy]"
              class="multiselect__tag"
            >
              <span>{{ value[optionLabel] }}</span>
              <i
                class="multiselect__tag-icon"
                aria-hidden="true"
                tabindex="1"
                @click="remove(value)"
              />
            </span>
          </div>
        </template>
      </template>
      <template
        slot="caret"
        slot-scope="{ toggle }"
      >
        <div
          class="multiselect__select"
          @mousedown.prevent.stop="toggle()"
        >
          <GjIcon
            class="icon-wrapper"
            name="ArrowDown_fill"
            size="21"
          />
        </div>
      </template>
    </multiselect>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Multiselect from 'vue-multiselect'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'

export default {
  components: {
    GjIcon,
    Multiselect,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    includedTags: {
      type: [Array, Object],
    },
    // eslint-disable-next-line vue/require-default-prop
    options: {
      type: [Array, Object],
    },
    placeholder: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    optionLabel: {
      type: String,
      default: 'option',
    },
    group: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    targetingProperty: {
      type: [Array, Object],
    },
    include: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      required: true,
    },
    isDuplicating: {
      type: Boolean,
      default: false,
    },
    groupValues: {
      type: String,
      default: 'options',
    },
    keyBy: {
      type: String,
      default: 'id',
    },
    optionsLimit: {
      type: Number,
      default: 100,
    },
  },
  setup(props, { emit, root }) {
    const isOverflowing = ref(false)
    const index = ref(-1)
    const includeTag = selectedOption => {
      emit('includeTag', selectedOption)
    }

    const removeTag = selectedOption => {
      emit('removeTag', selectedOption)
    }

    const addOption = selectedOption => {
      if (props.isDuplicating) {
        emit('addOption', selectedOption)
      } else {
        emit('addOption', props.targetingProperty, selectedOption, props.include)
      }
    }
    const removeOption = selectedOption => {
      if (props.isDuplicating) {
        emit('removeOption', selectedOption)
      } else {
        emit('removeOption', props.targetingProperty, selectedOption)
      }
    }

    // check if tags overflow content
    const isOverflow = () => {
      root.$nextTick(() => {
        const dropdown = document.querySelector(`#multiselect__tags--${props.id}`).parentElement
        const dropdownMoreButton = document.querySelector(`#multiselect__tag__more-${props.id}`)
        const dropdownTagsContainer = dropdown.querySelector('.multiselect__tags-wrap')
        const tags = dropdownTagsContainer.querySelectorAll('.multiselect__tag')
        const dropdownWidth = dropdown.offsetWidth
        let width = 0
        if (!dropdownMoreButton) { index.value = -1 }
        for (let i = 0; i < tags.length; i += 1) {
          width += tags[i].offsetWidth
          if (tags[i] === dropdownMoreButton) { break }
          if (dropdownWidth - 153 < width) {
            isOverflowing.value = true
            index.value = i
            break
          }
        }
      })
    }
    const handleOpen = () => {
      emit('open', props.id)
    }

    onMounted(() => {
      isOverflow()
    })

    watch(() => props.includedTags, () => {
      if (props.includedTags.length > 0) { isOverflow() }
    })

    return {
      includeTag,
      removeTag,
      addOption,
      removeOption,
      isOverflowing,
      index,
      handleOpen,
    }
  },
}
</script>

<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
<style lang="scss">
.multiselect__tag--dropdown{
  bottom: 10px;
  button.dropdown-toggle{
    padding: 0;
  }
  ul.dropdown-menu {
    padding: 4px;
     max-height: 280px;
     overflow-y: auto;
    li > a.dropdown-item {
      padding: 4px;
      height: 34px;
      cursor: default;
      &:hover {
        background-color: #fff !important;
      }
      span.multiselect__tag {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
